export default "__VITE_ASSET__2de8b16c__"